import './App.css';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './i18n';
import NavBar from './NavBar/NavBar';
import Hero from './Hero/Hero';
import About from './About/About';
import VisionMissionSection from './VisionMissionSection/VisionMissionSection';
import Services from './Services/Services';
import WhyInvestCameroonSection from './WhyInvestCameroonSection/WhyInvestCameroonSection';
import ContactUsSection from './ContactUsSection/ContactUsSection';
import Gallery from './Gallery/Gallery';
import Footer from './Footer/Footer';
import { Analytics } from '@vercel/analytics/react';

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.title = 'APED Investments';
  }, []);

  const toggleLanguage = () => {
    const newLang = i18n.language === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(newLang);
    localStorage.setItem('language', newLang);
  };

  return (
    <>
      <NavBar onToggleLanguage={toggleLanguage} currentLanguage={i18n.language} />
      <main>
        <div id="hero"><Hero /></div>
        <div id="about"><About /></div>
        <div id="vision-mission"><VisionMissionSection /></div>
        <div id="services"><Services /></div>
        <div id="why-invest"><WhyInvestCameroonSection /></div>
        <div id="contact"><ContactUsSection /></div>
        <div id="gallery"><Gallery /></div>
      </main>
      <Footer />
      <Analytics />
    </>
  );
}

export default App;
